import styled from "styled-components";
export const Container = styled.div`
    width: 100%;
    height: 315px;
    max-width: 1020px;
    min-width: 400px;
    position: relative;
    left: -40px;
`;
